// The ruby gem automatically adds newrelic to the browser which adds it to the window object.
export function noticeError(...args) {
  if (window.newrelic) {
    window.newrelic.noticeError(...args)
  }
}
